import { useFilter } from "../../../fetch/fetch.filter";
import { EMPTY_FILTER } from "../../../const/typeDefault/Filter";
import ErrMessage from "../../core/ErrMessage";
import { useSearchParamsHandler } from "../../../hooks/useSearchParamsHandler";
import { decode } from "./SingleFilter";

const FilterValue = ({ filterId }: { filterId: string }) => {
  const { get } = useSearchParamsHandler("filter");
  const { filter, isLoading, isError } = useFilter(filterId, EMPTY_FILTER);

  if (isLoading) return "...";
  if (isError) return <ErrMessage message={isError} />;

  const active = get().find((val) => decode(val)._id === filterId);
  if (!active) return filter.unit || null;
  const value = decode(active).value;
  const unit = filter.unit ?? "";
  switch (filter.outputType) {
    case "single":
      return `${value} ${unit}`;
    case "range":
      if (Array.isArray(value)) return `${value.join(" - ")} ${unit}`;
      return `${value} ${unit}`;
    case "multi":
      if (Array.isArray(value)) return `${value.join(", ")} ${unit}`;
      return `${value} ${unit}`;
  }
};
export default FilterValue;
